import { render, staticRenderFns } from "./print-identification-label.modal.vue?vue&type=template&id=00d86325&"
import script from "./print-identification-label.modal.vue?vue&type=script&lang=ts&"
export * from "./print-identification-label.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports